<template>
    <div class="row">
        <div class="col-12 mb-2">
            <div class="fine-summary-card border rounded-lg pb-1">
                <h5 class="mb-1 bg-light-primary px-1 py-75 border-bottom text-primary d-flex align-items-center">
                    <feather-icon icon="InfoIcon" size="20" class="mr-50" />
                    {{ $safe(fineDetails, "ReportNumber") }} Tutanak Numaralı Trafik Cezası
                </h5>
                <div class="row mx-0 px-50">
                    <div class="col-md-4 mb-1">
                        <div class="info-card d-flex align-items-center p-1 rounded">
                            <div class="avatar bg-light rounded mr-1">
                                <div class="avatar-content">
                                    <feather-icon icon="UserIcon" size="18" class="text-dark" />
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <small class="text-muted d-block mb-25">Personel</small>
                                <div class="font-weight-bolder text-dark">{{ $safe(fineDetails, "EmployeeFullName") }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 mb-1">
                        <div class="info-card d-flex align-items-center p-1 rounded">
                            <div class="avatar bg-light-info rounded mr-1">
                                <div class="avatar-content">
                                    <feather-icon icon="AlertOctagonIcon" size="18" class="text-info" />
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <small class="text-muted d-block mb-25">Ceza Maddesi</small>
                                <div class="font-weight-bolder text-dark">{{ $safe(fineDetails, "Clause") }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 mb-1">
                        <div class="info-card d-flex align-items-center p-1 rounded">
                            <div class="avatar bg-light-primary rounded mr-1">
                                <div class="avatar-content">
                                    <feather-icon icon="DollarSignIcon" size="18" class="text-primary" />
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <small class="text-muted d-block mb-25">Ceza Tutarı (TL)</small>
                                <div class="font-weight-bolder">{{ $safe(fineDetails, "PriceStr") }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 mb-0">
                        <div class="info-card d-flex align-items-center p-1 rounded">
                            <div class="avatar bg-light-warning rounded mr-1">
                                <div class="avatar-content">
                                    <feather-icon icon="CalendarIcon" size="18" class="text-warning" />
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <small class="text-muted d-block mb-25">Ceza Tarihi</small>
                                <div class="font-weight-bolder text-dark">{{ $safe(fineDetails, "FineDateStr") }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 mb-0">
                        <div class="info-card d-flex align-items-center p-1 rounded">
                            <div class="avatar bg-light-secondary rounded mr-1">
                                <div class="avatar-content">
                                    <feather-icon icon="MailIcon" size="18" class="text-secondary" />
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <small class="text-muted d-block mb-25">Tebliğ Tarihi</small>
                                <div class="font-weight-bolder text-dark">{{ $safe(fineDetails, "NotifyDateStr") }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 mb-0">
                        <div class="info-card d-flex align-items-center p-1 rounded">
                            <div class="avatar bg-light-success rounded mr-1">
                                <div class="avatar-content">
                                    <feather-icon icon="ArchiveIcon" size="18" class="text-success" />
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <small class="text-muted d-block mb-25">Kayıt Tarihi</small>
                                <div class="font-weight-bolder text-dark">{{ $safe(fineDetails, "CreateTimeStr") }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 mb-2">
            <table class="table table-sm table-bordered mb-0">
                <thead>
                    <tr class="bg-light">
                        <th></th>
                        <th class="text-right text-nowrap">Personel Payı</th>
                        <th class="text-right text-nowrap">Firma Payı</th>
                        <th class="text-right text-nowrap">Toplam</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="text-muted text-nowrap">Planlanan</td>
                        <td class="text-right text-nowrap">{{ formatAmount($safe(fineDetails, 'PlannedDriverAmount')) }}</td>
                        <td class="text-right text-nowrap">{{ formatAmount($safe(fineDetails, 'PlannedCompanyAmount')) }}</td>
                        <td class="text-right text-nowrap font-weight-bold">{{ formatAmount(plannedTotal) }}</td>
                    </tr>
                    <tr v-if="calculatedActualEmployee !== null">
                        <td class="text-nowrap text-success font-weight-bold">Gerçekleşecek</td>
                        <td class="text-right text-nowrap text-success font-weight-bold">{{ formatAmount(calculatedActualEmployee) }}</td>
                        <td class="text-right text-nowrap text-success font-weight-bold">{{ formatAmount(calculatedActualCompany) }}</td>
                        <td class="text-right text-nowrap text-success font-weight-bold">{{ formatAmount(selectedCalculatedAmount && selectedCalculatedAmount.PaymentAmount) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Ödeme Tarihi</label>
            <v-date-picker placeholder="Ödeme Tarihi" v-model="value.PaymentDate" :disabled-date="disableTebligDates"></v-date-picker>
        </div>
        <div v-if="calculatedAmounts.length > 0 && !calculating" class="col-12 mb-1">
            <div class="calculated-options-panel border rounded p-1">
                <div class="d-flex align-items-center justify-content-between flex-wrap mb-1">
                    <div>
                        <label class="form-label mb-25">Hesaplanan Tutar Seçenekleri <span class="text-danger">*</span></label>
                        <small class="text-muted d-block">Ödeme tarihine göre oluşan tutarlardan birini seçin.</small>
                    </div>
                    <span class="options-count-badge">{{ calculatedAmounts.length }} seçenek</span>
                </div>

                <div class="calculated-options-grid">
                    <button
                        type="button"
                        v-for="(item, index) in calculatedAmounts"
                        :key="index"
                        class="amount-option-card text-left"
                        :class="{ active: isSelectedCalculatedAmount(item) }"
                        @click="selectCalculatedAmount(item)"
                    >
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center">
                                <span class="option-bullet mr-50"></span>
                                <strong class="option-title">{{ item.TypeName }}</strong>
                            </div>
                            <span class="option-amount">{{ item.PaymentAmount }} TL</span>
                        </div>
                        <div class="mt-50">
                            <span v-if="item.InterestAmount > 0" class="interest-chip">Faiz: {{ item.InterestAmount }} TL</span>
                            <span v-else class="no-interest-chip">İndirim Uygulanmış</span>
                        </div>
                    </button>
                </div>
            </div>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Ödeme Yeri</label>
            <v-select-list :options="paymentPlaces" label="Name" placeholder="Ödeme Yeri" v-model="paymentPlace"></v-select-list>
        </div>
        <div v-if="value.PaymentPlace == 0" class="col-12 mb-1">
            <label class="form-label">Vergi Dairesi</label>
            <v-select-list v-model="taxAdministrator" :options="taxAdministrators" label="Name" placeholder="Vergi Dairesi"></v-select-list>
        </div>
        <div v-if="value.PaymentPlace == 1" class="col-12 mb-1">
            <label class="form-label">Bank</label>
            <v-select-list v-model="bank" :options="banks" label="BankName" placeholder="Bank"></v-select-list>
        </div>
        <div class="col-12">
            <label class="form-label">Dosya</label>
            <v-file-uploader v-model="value" :accept="['png', 'jpeg', 'jpg', 'xlsx', 'pdf']" value-parameter="Document"></v-file-uploader>
        </div>
    </div>
</template>

<script>
import SystemDataApi from "@/api/system-data";
import BankApi from "@/api/bank";
import VFileUploader from "@/components/v-file-uploader/VFileUploader.vue";
import EmployeeOperationsApi from "@/api/employee-operations";
export default {
    components: {
        VFileUploader,
    },
    props: {
        value: Object,
        fineDetails: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            paymentPlaces: [],
            taxAdministrators: [],
            banks: [],
            calculating: false,
            calculationError: null,
            calculatedAmounts: [],
            selectedCalculatedAmount: null,
            defaultTaxAdministratorId: null,
        };
    },
    mounted() {
        this.getPaymenPlaces();
        this.getBanks();
        this.getTaxAdministrators();
    },
    watch: {
        "value.PaymentDate"(newDate) {
            this.calculatedAmounts = [];
            this.selectedCalculatedAmount = null;
            this.calculationError = null;
            this.value.PaidAmount = null;

            if (!newDate) return;

            if (this.defaultTaxAdministratorId && !this.value.TaxAdministrationId) {
                this.$set(this.value, "TaxAdministrationId", this.defaultTaxAdministratorId);
            }
            if (this.value.PaymentPlace === null || this.value.PaymentPlace === undefined) {
                this.$set(this.value, "PaymentPlace", 0);
            }

            this.calculating = true;
            EmployeeOperationsApi.TrafficFine.Payment.Calculate(this.value.EmployeeTrafficFineId, newDate)
                .then((res) => {
                    if (res.data.Success && res.data.Data?.length > 0) {
                        this.calculatedAmounts = res.data.Data;
                        const dailyOption = this.calculatedAmounts.find((item) => item.TypeName?.includes("Günlük"));

                        if (dailyOption) {
                            this.selectedCalculatedAmount = dailyOption;
                        } else if (this.calculatedAmounts.length > 0) {
                            this.selectedCalculatedAmount = this.calculatedAmounts[0];
                        }
                    } else {
                        this.calculationError = res.data.Message || "Bu tarih için hesaplanacak tutar bulunamadı.";
                    }
                })
                .catch((err) => {
                    this.calculationError = "Tutar hesaplanırken bir hata oluştu.";
                    this.$result(null, err);
                })
                .finally(() => {
                    this.calculating = false;
                });
        },

        selectedCalculatedAmount(selection) {
            this.value.PaidAmount = selection?.PaymentAmount ?? null;
        },
    },
    methods: {
        getPaymenPlaces() {
            SystemDataApi.TrafficFinePaymentPlace().then((res) => {
                this.paymentPlaces = res.data.Data || [];
            });
        },
        getTaxAdministrators() {
            SystemDataApi.TaxAdministrationList().then((res) => {
                this.taxAdministrators = res.data.Data;
                const defaultTax = this.taxAdministrators.find((t) => t.Name && t.Name.toUpperCase().includes("ÇINAR"));
                if (defaultTax) {
                    this.defaultTaxAdministratorId = defaultTax.Id;
                    if (!this.value.TaxAdministrationId) {
                        this.value.TaxAdministrationId = defaultTax.Id;
                    }
                    if (this.value.PaymentPlace === null || this.value.PaymentPlace === undefined) {
                        this.$set(this.value, "PaymentPlace", 0);
                    }
                }
            });
        },
        getBanks() {
            BankApi.List().then((res) => {
                this.banks = res.data.Data;
            });
        },
        selectCalculatedAmount(item) {
            this.selectedCalculatedAmount = item;
        },
        isSelectedCalculatedAmount(item) {
            return this.selectedCalculatedAmount === item;
        },
        formatAmount(val) {
            if (val === null || val === undefined) return "-";
            return Number(val).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " ₺";
        },
        disableTebligDates(date) {
            const today = new Date();
            today.setHours(23, 59, 59, 999);
            if (date > today) {
                return true;
            }

            if (this.$safe(this.fineDetails, "NotifyDate")) {
                const fineDateStart = new Date(this.$safe(this.fineDetails, "NotifyDate"));
                fineDateStart.setHours(0, 0, 0, 0);
                if (date < fineDateStart) {
                    return true;
                }
            }

            return false;
        },
    },
    computed: {
        plannedTotal() {
            const e = Number(this.$safe(this.fineDetails, 'PlannedDriverAmount')) || 0;
            const c = Number(this.$safe(this.fineDetails, 'PlannedCompanyAmount')) || 0;
            return e + c || null;
        },
        calculatedActualEmployee() {
            const paid = this.selectedCalculatedAmount ? Number(this.selectedCalculatedAmount.PaymentAmount) : null;
            if (!paid || !this.plannedTotal) return null;
            const ratio = (Number(this.$safe(this.fineDetails, 'PlannedDriverAmount')) || 0) / this.plannedTotal;
            return Math.round(paid * ratio * 100) / 100;
        },
        calculatedActualCompany() {
            const paid = this.selectedCalculatedAmount ? Number(this.selectedCalculatedAmount.PaymentAmount) : null;
            if (this.calculatedActualEmployee === null || paid === null) return null;
            return Math.round((paid - this.calculatedActualEmployee) * 100) / 100;
        },
        paymentPlace: {
            get: function () {
                return this.paymentPlaces.find((b) => b.Value == this.value.PaymentPlace);
            },
            set: function (value) {
                this.value.PaymentPlace = value?.Value ?? null;
            },
        },
        taxAdministrator: {
            get: function () {
                return this.taxAdministrators.find((b) => b.Id == this.value.TaxAdministrationId);
            },
            set: function (value) {
                this.value.TaxAdministrationId = value?.Id || null;
            },
        },
        bank: {
            get: function () {
                return this.banks.find((b) => b.Id == this.value.BankId);
            },
            set: function (value) {
                this.value.BankId = value?.Id || null;
            },
        },
    },
};
</script>

<style>
.fine-summary-card {
    background: var(--card-bg-light);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
    transition: box-shadow 0.3s ease, background-color 0.3s ease;
}

.fine-summary-card:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
}

.info-card {
    background: var(--card-bg-light);
    border: 1px solid var(--card-border-light);
    transition: all 0.3s ease;
}

.info-card:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-color: #d1d5db;
}

.dark-layout .info-card {
    border: 1px solid #4f5d70bb;
}

.payment-amount-card {
    background: linear-gradient(135deg, rgba(40, 199, 111, 0.05) 0%, rgba(40, 199, 111, 0.02) 100%);
    border-color: rgba(40, 199, 111, 0.3) !important;
    transition: all 0.3s ease;
}

.payment-amount-card:hover {
    box-shadow: 0 4px 12px rgba(40, 199, 111, 0.15);
}

.avatar {
    width: 42px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: auto;
}

.avatar-content {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: auto;
}

.interest-chip {
    display: inline-flex;
    align-items: center;
    padding: 0.1rem 0.5rem;
    border-radius: 999px;
    font-size: 0.74rem;
    font-weight: 600;
    line-height: 1.35;
    white-space: nowrap;
    color: #b91c1c;
    background: rgba(239, 68, 68, 0.14);
    border: 1px solid rgba(239, 68, 68, 0.35);
}

.dark-layout .interest-chip {
    color: #fecaca;
    background: rgba(239, 68, 68, 0.22);
    border-color: rgba(248, 113, 113, 0.45);
}

.calculated-options-panel {
    background: rgba(115, 103, 240, 0.04);
    border-color: rgba(115, 103, 240, 0.2) !important;
}

.options-count-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.2rem 0.55rem;
    font-size: 0.72rem;
    font-weight: 600;
    border-radius: 999px;
    color: #5e50ee;
    background: rgba(115, 103, 240, 0.14);
}

.calculated-options-grid {
    display: grid;
    gap: 0.55rem;
}

.amount-option-card {
    width: 100%;
    border: 1px solid #d8d6de;
    border-radius: 0.55rem;
    background: #fff;
    padding: 0.75rem;
    transition: all 0.2s ease;
}

.amount-option-card:hover {
    border-color: #7a6ff0;
    box-shadow: 0 4px 14px rgba(115, 103, 240, 0.14);
}

.amount-option-card.active {
    border-color: #5e50ee;
    background: linear-gradient(180deg, rgba(115, 103, 240, 0.1) 0%, rgba(115, 103, 240, 0.04) 100%);
    box-shadow: 0 6px 18px rgba(115, 103, 240, 0.18);
}

.option-bullet {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: 2px solid #b9b4f9;
    background: transparent;
}

.amount-option-card.active .option-bullet {
    border-color: #5e50ee;
    background: #5e50ee;
}

.option-title {
    font-size: 0.95rem;
    color: #3b3b4f;
}

.option-amount {
    font-size: 1rem;
    font-weight: 700;
    color: #28c76f;
}

.no-interest-chip {
    display: inline-flex;
    align-items: center;
    padding: 0.1rem 0.45rem;
    border-radius: 999px;
    font-size: 0.72rem;
    font-weight: 500;
    color: #16784b;
    background: rgba(40, 199, 111, 0.14);
    border: 1px solid rgba(40, 199, 111, 0.35);
}

.dark-layout .calculated-options-panel {
    background: rgba(115, 103, 240, 0.1);
    border-color: rgba(138, 129, 243, 0.4) !important;
}

.dark-layout .options-count-badge {
    color: #d5d1ff;
    background: rgba(115, 103, 240, 0.26);
}

.dark-layout .amount-option-card {
    background: #283046;
    border-color: #3b4253;
}

.dark-layout .amount-option-card:hover {
    border-color: #8b82f8;
}

.dark-layout .amount-option-card.active {
    border-color: #8b82f8;
    background: linear-gradient(180deg, rgba(115, 103, 240, 0.22) 0%, rgba(115, 103, 240, 0.1) 100%);
}

.dark-layout .option-title {
    color: #f5f5f8;
}

.dark-layout .option-bullet {
    border-color: #9d96f9;
}

.dark-layout .no-interest-chip {
    color: #b8f6d2;
    background: rgba(40, 199, 111, 0.2);
    border-color: rgba(40, 199, 111, 0.45);
}
</style>
